import axios from 'axios'

/**
 * THe RestService provides a wrapper around the axios library so that we can add additional
 * centralized behavior around requests and responses.  One of the things the useRest functions
 * provide is the ability to detect that the auth.js middleware has determined that the request
 * is unauthenticated and a redirect is needed to a login page.  The get and post functions will
 * handle that.
 *
 * Other functionaliy can be added to this as required by the application.
 */

 axios.defaults.headers.common['Cache-Control'] = 'no-cache';

export default function useRestClient() {
  function get(url) {
    const promise = new Promise(async (resolve, reject) => {
      try {
        //Set the X-Requested-with header so that the request.xhr property is set to
        //true in express.
        let config = {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        }
        const result = await axios.get(url, config)
        resolve(result.data)
      } catch (error) {
        console.log(error)
        reject(error.response.data)
      }
    })

    return promise
  }

  function post(url, payload) {
    const promise = new Promise(async (resolve, reject) => {
      try {
        //Set the X-Requested-with header so that the request.xhr property is set to
        //true in express.
        let config = {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        }
        const result = await axios.post(url, payload, config)
        resolve(result.data)
      } catch (error) {
        reject(error)
      }
    })

    return promise
  }

  return { get, post }
}

